export const getFirstSegmentOfPathname = (pathname: string) => {
  const segments = pathname.split('/').filter(Boolean)
  return segments[0] || '/'
}
